import { Injectable, OnDestroy } from '@angular/core';
import { Subject } from 'rxjs';
import { MessageOptionsInterface } from './message-options.model';
import { MessageType } from './message-type.enum';
import { MessageInterface } from './message.model';

@Injectable()
export class HeaderMessageService implements OnDestroy {
  message$: Subject<MessageInterface> = new Subject();

  open(message: string, type: MessageType, options?: MessageOptionsInterface) {
    this.message$.next({ text: message, type, options });
  }

  close() {
    this.message$.next(null);
  }

  getMessageSubject() {
    return this.message$;
  }

  ngOnDestroy() {
    if (typeof this.message$ !== 'undefined') {
      this.message$.unsubscribe();
    }
  }
}
